/*@ngInject*/
const BaseWidgetController = function ($scope, coreConstant) {

    this.onInit = function () {
        this.defaultWidgetConfig = _.cloneDeep(this.widgetConfig);
    };

    this.minimize = function ($event) {
        if (!this.isMinimized()) {
            this.widgetConfig.sizeX = this.widgetConfig.minSizeX || 1;
            this.widgetConfig.sizeY = this.widgetConfig.minSizeY || 1;
            $scope.$emit(coreConstant.event.widget.RESIZE_STOP);
        } else {
            $event.stopPropagation();
        }
    };

    this.maximize = function ($event) {
        if (!this.isMaximized()) {
            this.widgetConfig.sizeX = 6;
            this.widgetConfig.sizeY = 4;
            this.widgetConfig.row = 0;
            this.widgetConfig.col = 0;
            $scope.$emit(coreConstant.event.widget.RESIZE_STOP);
        } else {
            $event.stopPropagation();
        }
    };

    this.returnToDefaultSize = function ($event) {
        if (!this.isAtDefaultSize()) {
            this.widgetConfig.sizeX = this.defaultWidgetConfig.sizeX;
            this.widgetConfig.sizeY = this.defaultWidgetConfig.sizeY;
            $scope.$emit(coreConstant.event.widget.RESIZE_STOP);
        } else {
            $event.stopPropagation();
        }
    };

    this.isMinimized = function () {
        return (this.widgetConfig.sizeX === this.widgetConfig.minSizeX || this.widgetConfig.sizeX === 1) &&
            (this.widgetConfig.sizeY === this.widgetConfig.minSizeY || this.widgetConfig.sizeY === 1);
    };

    this.isMaximized = function () {
        return this.widgetConfig.sizeX === 6 &&
            this.widgetConfig.sizeY === 4 &&
            this.widgetConfig.row === 0 &&
            this.widgetConfig.col === 0;
    };

    this.isAtDefaultSize = function () {
        return this.widgetConfig.sizeX === this.defaultWidgetConfig.sizeX &&
            this.widgetConfig.sizeY === this.defaultWidgetConfig.sizeY;
    };

};

angular.module('umCore')
    .controller('baseWidgetController', BaseWidgetController);
